import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { RolActividad } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityRolesActividadLoadRequest = createAction(
  '[ENTITYROLESACTIVIDAD] Load Request'
);

export const entityRolesActividadLoadFailure = createAction(
  '[ENTITYROLESACTIVIDAD] Load Failure',
  props<{ error: Error }>()
);

export const entityRolesActividadLoadSuccess = createAction(
  '[ENTITYROLESACTIVIDAD] Load Success',
  props<{ items: RolActividad[] }>()
);

// ADD
export const entityRolesActividadAddRequest = createAction(
  '[ENTITYROLESACTIVIDAD] Add Request',
  props<{ item: RolActividad }>()
);

export const entityRolesActividadAddFailure = createAction(
  '[ENTITYROLESACTIVIDAD] Add Failure',
  props<{ error: Error }>()
);

export const entityRolesActividadAddSuccess = createAction(
  '[ENTITYROLESACTIVIDAD] Add Success',
  props<{ item: RolActividad }>()
);

// CHANGE
export const entityRolesActividadChangeRequest = createAction(
  '[ENTITYROLESACTIVIDAD] Change Request',
  props<{ item: RolActividad }>()
);

export const entityRolesActividadChangeFailure = createAction(
  '[ENTITYROLESACTIVIDAD] Change Failure',
  props<{ error: Error }>()
);

export const entityRolesActividadChangeSuccess = createAction(
  '[ENTITYROLESACTIVIDAD] Change Success',
  props<{ item: Update<RolActividad> }>()
);

// CHANGE VINCUlACIONES
export const entityVinculacionesRolActividadChangeRequest = createAction(
  '[ENTITYVINCULACIONESROLACTIVIDAD] Change Request',
  props<{ item: RolActividad[] }>()
);

export const entityVinculacionesRolActividadChangeFailure = createAction(
  '[ENTITYVINCULACIONESROLACTIVIDAD] Change Failure',
  props<{ error: Error }>()
);

export const entityVinculacionesRolActividadChangeSuccess = createAction(
  '[ENTITYVINCULACIONESROLACTIVIDAD] Change Success',
  props<{ item: Update<RolActividad>[]; rolId: number }>()
);

// DELETE
export const entityRolesActividadDeleteRequest = createAction(
  '[ENTITYROLESACTIVIDAD] Delete Request',
  props<{ item: RolActividad }>()
);

export const entityRolesActividadDeleteFailure = createAction(
  '[ENTITYROLESACTIVIDAD] Delete Failure',
  props<{ error: Error }>()
);

export const entityRolesActividadDeleteSuccess = createAction(
  '[ENTITYROLESACTIVIDAD] Delete Success',
  props<{ item: RolActividad }>()
);
